<script>
export default {
  computed: {
    logo() {
      return this.siteData?.logo || require('@/assets/img/bgDrawer.jpg')
    },
    subLogo() {
      return this.siteData?.sub_logo
    },
    footerBlocks() {
      return this.siteData ? Object.keys(this.siteData).reduce((acc, k) => {
        if(k.startsWith('footer_')) acc[k] = this.siteData[k]
        return acc
      }, {}) : null
    }
  }
}
</script>

<template>
  <v-footer light padless>
    <v-card class="light-blue lighten-5 footer">
      <v-card-text class="black--text">
        <v-container :fluid="isMiniPc">
          <v-row>
            <v-col sm="3">
							<div class="logo" v-if="subLogo">
              	<v-img :src="logo" height="100px" position="left" ></v-img>
							</div>
              <div v-html="subLogo"></div>
            </v-col>
            <template v-if="footerBlocks">
              <v-col cols="12" sm="3" v-for="i in 3" :key="`block-${i}`">
                <div v-html="footerBlocks[`footer_${i}_block`]"></div>
              </v-col>
            </template>
          </v-row>
        </v-container>
        <div class="text-center">
          {{ new Date().getFullYear() }} — <strong>Kolay Maliyet | Tüm Hakları Saklıdır. </strong>
        </div>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped lang="scss">
.v-card {
  width: 100%;
}
::v-deep .footer {
  a {
    text-decoration: none !important;
    span {
      text-decoration: none !important;
    }
  }
}
</style>
